"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Calendar } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsCalendar() {
  const [date, setDate] = React.useState<Date | undefined>(new Date());
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Calendar
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A date picker component with support for single date selection.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/calendar" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>An interactive calendar</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="flex justify-center">
            <Calendar
              mode="single"
              selected={date}
              onSelect={setDate}
              className="rounded-md border"
            />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">mode</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"single" | "multiple" | "range"</td>
                <td className="py-2 text-muted-foreground">Selection mode</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">selected</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">Date | Date[] | DateRange</td>
                <td className="py-2 text-muted-foreground">Selected date(s)</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onSelect</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">function</td>
                <td className="py-2 text-muted-foreground">Selection change handler</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">disabled</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">Matcher | Matcher[]</td>
                <td className="py-2 text-muted-foreground">Dates to disable</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
